import { Component } from '@verndale/core';
import axios from 'axios';

class Module extends Component {
  setupDefaults() {
    this.actionStopper = true;
    this.endpoint = this.el.dataset.goalTrackerEndpoint;
  }

  addListeners() {
    document.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(e) {
    const { target } = e;
    const dataset = Object.assign({}, target.dataset);

    if (!Object.keys(dataset).includes('goal')) return;

    if (!this.actionStopper) {
      this.actionStopper = true;
      return true;
    }

    e.preventDefault();
    this.actionStopper = false;
    this.trackGoal(target, dataset);

    return false;
  }

  async trackGoal(target, dataset) {
    const params = {
      json: true,
      goalId: dataset.goal
    };
    const data = Object.keys(dataset).filter(
      params => params !== 'goal' && params.startsWith('goal')
    );

    data.forEach(param => {
      const dataName = param.replace('goal', '');
      return (params[`${dataName[0].toLowerCase()}${dataName.slice(1)}`] =
        dataset[param]);
    });

    await axios.get(this.endpoint, { params });

    this.simulateClick(target);
  }

  simulateClick(target) {
    const evt = new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window
    });

    target.dispatchEvent(evt);
  }
}

export default Module;
